import {styled, Typography} from "@mui/material";
import {useTheme} from "@mui/system";
import TableSelectTax from "components/Input/TableSelectTax";
import {PriceComponent} from "components/Shared/Dashboard/styled";
import {useSelector} from "react-redux";
import {formatPrice} from "helpers/dataFormat";
import {indexData} from "forms";
import useDateState from "helpers/useDateState";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import PlusIcon from "assets/icons/PlusIcon";

type TypeVar = "success" | "error";

const MainContainer = styled("div")(({theme}) => ({
    borderRadius: theme.shape.borderRadius,
    margin: "20px",
    display: "flex",
    flexDirection: "column",
}));
const LowerSectionContainer = styled("div")(({theme}) => {
    return {
        display: "flex",
        flexWrap: "wrap",
        gap: "24px",
        padding: "10px",
        borderRadius: ` 0 0 ${theme.shape.borderRadius} ${theme.shape.borderRadius}`,
        width: "100%",
        justifyContent: "start",
    };
});
const UpperSection = styled("div")(({theme}) => ({
    display: "flex",
    alignItems: "center",
    gap: 20,
    padding: "10px",
    borderRadius: `${theme.shape.borderRadius} ${theme.shape.borderRadius} 0 0`,
    paddingRight: "20px",
    width: "100%",
}));

const ReportItemContainer = styled("div")(({theme, type}: { theme?: ThemeObjType; type?: TypeVar }) => ({
    width: "100%",
    backgroundColor: "#ffffff",
    borderRight: `solid 4px ${theme?.palette[type || "success"].main}`,
    borderRadius: theme?.shape.borderRadius,
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    justifyContent: "space-evenly",
    padding: "10px",
}));
const ReportRightItem = styled("div")(({theme}) => ({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
}));
const ReportLeftItem = styled("div")(({theme}) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    justifyContent: "space-between",
}));

const PriceItemContainer = styled("div")(({theme}) => ({
    display: "flex",
    gap: 8,
    alignItems: "center",
    whiteSpace: "nowrap",
}));

const ReportItem = ({
                        type,
                        totalPrice,
                        totalTaxAndTaxation,
                        totalTaxation,
                        totalTax,
                    }: {
    type: TypeVar;
    totalPrice?: number;
    totalTaxAndTaxation?: number;
    totalTaxation?: number;
    totalTax?: number;
}) => {
    const theme = useTheme();

    return (
        <ReportItemContainer type={type}>
            <ReportRightItem>
                <Typography fontSize={16} fontWeight={500} color={theme?.palette[type].main}>
                    {type === "success" ? "خرید" : "فروش"}
                </Typography>
                <PriceItemContainer>
                    <PriceComponent variant="h5" price={formatPrice(totalPrice)}/>
                </PriceItemContainer>
            </ReportRightItem>
            <ReportLeftItem>
                <PriceItemContainer>
                    <Typography fontSize={14} color={"#7E8C9E"}>
                        کل فروش
                    </Typography>
                    <PriceComponent price={formatPrice(totalTaxAndTaxation)}/>
                </PriceItemContainer>
                <div className="flex items-center gap-2">
                    <span>{"("}</span>
                    <PriceItemContainer>
                        <Typography fontSize={14} color={"#7E8C9E"}>
                            عوارض
                        </Typography>
                        <PriceComponent price={formatPrice(totalTaxation)}/>
                    </PriceItemContainer>
                    <PlusIcon scale={0.7} color="#576271"/>
                    <PriceItemContainer>
                        <Typography fontSize={14} color={"#7E8C9E"}>
                            مالیات
                        </Typography>
                        <PriceComponent price={formatPrice(totalTax)}/>
                    </PriceItemContainer>
                    <span>{")"}</span>
                </div>
            </ReportLeftItem>
        </ReportItemContainer>
    );
};

const TaxReportUpperComponent = ({
                                     refetch,
                                     type,
                                 }: {
    refetch: (paginationState: any, token: any, productId: any) => void;
    type: string;
}) => {
    const reportReducer = useSelector((state: any) => state).reportReducer;
    const allInformation = reportReducer?.taxReport?.allInformation;
    const tabs = indexData(type);
    const {setDates, fromDate, toDate} = useDateState(tabs && tabs[0]);

    return (
        <MainContainer>
            <UpperSection>
                <div style={{width: 245}}>
                    <BasicDateInput
                        range
                        placeholder="کل سال مالی"
                        onChange={(x) => setDates(x)}
                        defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
                    />
                </div>
                <TableSelectTax refetch={refetch}/>
            </UpperSection>
            <div className="flex flex-wrap md:flex-nowrap gap-2 my-4">
                <ReportItem
                    type="error"
                    totalPrice={allInformation?.totalPriceSale}
                    totalTaxAndTaxation={allInformation?.totalTaxAndTaxationSale}
                    totalTaxation={allInformation?.totalTaxationSale}
                    totalTax={allInformation?.totalTaxSale}
                />
                <ReportItem
                    type="success"
                    totalPrice={allInformation?.totalPriceBuy}
                    totalTaxAndTaxation={allInformation?.totalTaxAndTaxationBuy}
                    totalTaxation={allInformation?.totalTaxationBuy}
                    totalTax={allInformation?.totalTaxBuy}
                />
            </div>
        </MainContainer>
    );
};

export default TaxReportUpperComponent;
